import { IRestaurantGroup } from "@src/store/app_manager/types";
import { instance } from "./api";
import { CreateIntegrateWithExistCredentialPayload } from "@src/pages/LocationPage/components/Yandex/domain/createIntegrateWithExistCredential";
import { CreateYandexCredentialsPayload } from "@src/pages/LocationPage/components/Yandex/domain/createYandexCredentials";

export const locationsApi = {
  getLocations(payload: any, query: string): any {
    return instance.get(`/v3/locations?page=${payload.page}&limit=10${query}`);
  },
  getRestaurantsGroup() {
    return instance.get<IRestaurantGroup[]>(`/v3/locations/group`);
  },
  getRestaurantsGroupWithDelivery(delivery: string) {
    return instance.get<IRestaurantGroup[]>(
      `/v3/locations/group?aggregator_name=${delivery}`
    );
  },

  getUserList() {
    return instance.get(`/v2/user`);
  },

  getLocationById(restaurantId: string) {
    return instance.get(`/v3/locations/${restaurantId}`);
  },
  deleteLocations(restaurantId: string) {
    return instance.delete(`/v2/location/${restaurantId}`);
  },
  editLocationData(restaurantId: string, body: any) {
    return instance.put(`/v3/locations`, body);
  },
  addRestaurant(body: any) {
    return instance.post(`/v3/locations`, body);
  },
  getLocationSettings() {
    return instance.get(`/v2/location/settings`);
  },
  get_orgnizations(api_login: string, pos_type: string) {
    return instance.get(`/v3/iiko/organizations?api_login=${api_login}`);
  },
  editChecksField(body: any) {
    return instance.put(`v2/location/setting/bill-params`, body);
  },
  getPosIds(api_login: string, pos_type: string) {
    return instance.get(
      `v1/pos/organizations?api_login=${api_login}&pos_type=${pos_type}`
    );
  },
  createOrganizations(body: any) {
    return instance.put(`/v3/pos/organizations`, body);
  },
  getPaymentTypes(rest_id: string) {
    return instance.get(`/v3/iiko/payment_types?restaurant_id=${rest_id}`);
  },
  getOrderTypes(restaurantId: string) {
    return instance.get(`/v3/iiko/order_types/${restaurantId}`);
  },
  disableLocationIntegration(location_id: string, is_integrated: boolean) {
    return instance.post(`/v3/locations/${location_id}/integration`, {
      available: is_integrated,
    });
  },
  getStoplistBalance(restaurant_id: string) {
    return instance.get(`/v2/location/${restaurant_id}/iiko-stoplist-balance`);
  },
  editStoplistBalance(restaurant_id: string, byBalance: boolean) {
    return instance.patch(
      `/v2/location/${restaurant_id}/stoplist-by-balance`,
      {},
      {
        params: {
          by_balance: byBalance ? "true" : "false",
        },
      }
    );
  },
  editStoplistLimit(restaurant_id: string, limit: string) {
    return instance.patch(
      `/v2/location/${restaurant_id}/stoplist-balance-limit`,
      {},
      {
        params: {
          balance_limit: limit,
        },
      }
    );
  },
  // EDIT LOCATIONS
  getCashSystem(restaurantId: string) {
    return instance.get(`/v3/iiko/organizations/${restaurantId}`);
  },
  editCashSystem(body: any) {
    return instance.put(`/v3/iiko/organizations`, body);
  },
  patchIntegration(body: any) {
    return instance.patch(`/v3/integrations`, body);
  },
  getLanguages() {
    return instance.get(`/v3/locations/languages`);
  },
  getCurrencies() {
    return instance.get(`/v3/locations/currencies`);
  },
  // 3rd step routes
  createGlovoIntegration(body: any) {
    return instance.post(`/v3/integrations/glovo`, body);
  },
  createWoltIntegration(body: any) {
    return instance.post(`/v3/integrations/wolt`, body);
  },

  getAggregatorData(restaurantId: string, aggregator: string) {
    return instance.get(
      `/v3/integrations/${restaurantId}?aggregator=${aggregator}`
    );
  },
  updateWoltData(body: any) {
    return instance.post(`/v3/integrations/update/wolt`, body);
  },
  updateAggregatorData(body: any, aggregator: string) {
    return instance.post(`/v3/integrations/update/${aggregator}`, body);
  },
  getAllRestaurants() {
    return instance.get(`/v3/locations/group`);
  },

  // YANDEX
  getYandexCredentials(restaurantId: string) {
    return instance.get(`v3/integrations/yandex?rest_id=${restaurantId}`);
  },
  getAllYandexCredentials() {
    return instance.get(`v2/integration/yandex/credentials`);
  },
  createYandexIntegrations(body: CreateYandexCredentialsPayload) {
    return instance.post(`v2/integration/yandex/credentials`, body);
  },
  createYandexIntegrationWithExistCredential(
    body: CreateIntegrateWithExistCredentialPayload
  ) {
    return instance.post(`v2/integration/yandex/credentials/store`, body);
  },
};
